import { useState, useEffect } from "react";
import { handleError } from "utils/errorHandler";

export interface VisitorInfo {
  country: string;
  countryCode: string;
  city: string;
}

export function useVisitorInfo(): VisitorInfo {
  const [info, setInfo] = useState<VisitorInfo>({
    country: "",
    countryCode: "",
    city: "",
  });

  useEffect(() => {
    const fetchCountry = async () => {
      try {
        const res = await fetch("https://ipapi.co/json/");
        const data = await res.json();
        if (data.country_name) {
          setInfo({
            country: data.country_name,
            countryCode: data.country_code,
            city:
              data.region && data.region !== data.country_name
                ? data.region
                : "",
          });
        } else {
          setInfo({ country: "Your Location", countryCode: "US", city: "" });
        }
      } catch (error) {
        handleError(error, {
          component: "useVisitorInfo",
          operation: "fetchCountry",
          service: "ipapi.co",
        });
        setInfo({ country: "Your Location", countryCode: "US", city: "" });
      }
    };
    fetchCountry();
  }, []);

  return info;
}
